import React from "react";
import PropTypes from "prop-types";
import { Wrapper } from "../../../../constants/common/StyledGlobalConstants";
import "../ContactDetails.css";
import { useSelector } from "react-redux";

const ContactRadioCard = ({ values, handleContactSwitch, defaultValue, ariaLabel }) => {
  const { userSelectedContactOption, userSelectedAddressOption } = useSelector((state) => state.TECHNICIANAPPOINTMENT);
  return (
    <Wrapper marginTop="24px !important" width="100%" className="radioContainer">
      {values.map((radiofield) => {
        return (
          <div key={radiofield.label} className="radioCard">
            <div className="radioFlex">
              <input
                className="customRadioStyle"
                type="radio"
                aria-label={ariaLabel}
                onChange={(e) => handleContactSwitch(e.target.name, e.target.value)}
                id={radiofield.inputId}
                name={radiofield.name}
                value={radiofield.value}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleContactSwitch(e.target.name, e.target.value);
                  }
                }}
                checked={
                  radiofield.name === "contact" ? radiofield.value === userSelectedContactOption : radiofield.value === userSelectedAddressOption
                }
              />
              <label className="radioCardLabel" htmlFor={radiofield.inputId}>
                {radiofield.label}
              </label>
            </div>
            {radiofield.children}
          </div>
        );
      })}
    </Wrapper>
  );
};
ContactRadioCard.propTypes = {
  values: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      inputId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
      children: PropTypes.node
    })
  ).isRequired,
  handleContactSwitch: PropTypes.func.isRequired,
  defaultValue: PropTypes.any,
  ariaLabel: PropTypes.string
};

export default ContactRadioCard;